<template>
  <div class="w-full">
    <Pie
      :data="chartData"
      :options="chartOptions"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script setup lang="ts">
import { safeDenominator } from '@/helpers';
import { t } from '@/i18n';
import Delay, { DelayStatusColours, DelayStatusTitles } from '@/models/Delay';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { computed } from 'vue';
import { Pie } from 'vue-chartjs';

// Register ChartJS components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
);

const props = defineProps<{
  delaysByStatus: Map<string, Delay[]>;
  delaysSummary: DelaysSummary;
}>();

// Chart configuration
const chartId = 'delays-status-chart';
const datasetIdKey = 'label';
const plugins = [];
const cssClasses = '';
const styles = {};
const width = undefined;
const height = undefined;

const chartData = computed(() => {
  const delays = Array.from(props.delaysByStatus.keys());

  const delaysPerStatus = Array.from(props.delaysByStatus.values()).map((delays) => {
    return delays.length;
  });

  const statusLabels = delays.map((status) => {
    return t(`Models.Delay.statusTitles.${status}`);
  });

  const colours = delays.map((status) => {
    return DelayStatusColours[status];
  });

  return {
    labels: statusLabels,
    datasets: [{
      data: delaysPerStatus,
      backgroundColor: colours,
      hoverOffset: 4,
    }],
  };
});

const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom' as const,
    },

    tooltip: {
      callbacks: {
        label(this: any, tooltipItem: any) {
          return `${tooltipItem.dataset.data[tooltipItem.dataIndex]} (${
            (tooltipItem.dataset.data[tooltipItem.dataIndex] / safeDenominator(props.delaysSummary.total_delays) *
              100)
              .toFixed(2)
          }%)`;
        },
      },
    },
  },

  maintainAspectRatio: false,
};
</script>

<style scoped></style>
